import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { Button, Icon } from '@picsio/ui';
import { ToriutLogo } from '@picsio/icons';
import PropTypes from 'prop-types';

import picsioConfig from '../../../../../config';
import l10n from '../../shared/strings';
import Logger from '../../services/Logger';
import LogoIcon from '../Icon';
import styles from './styles.module.scss';

const ImportInboxPromoBanner = (props) => {
  const { icon, title, description } = props;
  const theme = useSelector((state) => state.import.theme);
  const titleText = picsioConfig.isPim ? l10n.IMPORT_INBOX_PROMO_BANNER.TORIUT.title : l10n.IMPORT_INBOX_PROMO_BANNER.PICSIO.title;
  const descriptionText = picsioConfig.isPim ? l10n.IMPORT_INBOX_PROMO_BANNER.TORIUT.description : l10n.IMPORT_INBOX_PROMO_BANNER.PICSIO.description;
  const iconColor = theme === 'light' ? '#3B94FB' : '#ffc000';

  const renderIcon = () => {
    if (icon) {
      return (
        <Icon size="xl">
          {icon}
        </Icon>
      );
    }

    if (picsioConfig.isPim) {
      return (
        <Icon size="xl" style={{ color: iconColor }}>
          <ToriutLogo className={styles.promoBannerIcon} />
        </Icon>
      );
    }

    return <LogoIcon size="xl" className={styles.promoBannerIcon} name="logoPicsio" style={{ color: iconColor }} />;
  };

  const onClick = useCallback(() => {
    Logger.log('User', 'InboxSharePagePromBannerTryButtonClicked');
    const url = picsioConfig.isPim
      ? 'https://toriut.com?utm_campaign=inbox_upload_promo'
      : 'https://pics.io?utm_campaign=inbox_upload_promo';
    window.open(url, '_blank');
  }, []);

  return (
    <div className={styles.promoBanner}>
      {renderIcon()}
      <div className={styles.promoBannerTextBlock}>
        <span className={styles.promoBannerTitle}>{title || titleText}</span>
        <span className={styles.promoBannerDescription}>{description || descriptionText}</span>
      </div>
      <Button className={styles.promoBannerButton} color="primary" onClick={onClick}>
        {l10n.IMPORT_INBOX_PROMO_BANNER.BUTTON_TEXT}
      </Button>
    </div>
  );
};

ImportInboxPromoBanner.propTypes = {
  icon: PropTypes.element,
  title: PropTypes.string,
  description: PropTypes.string,
};

ImportInboxPromoBanner.defaultProps = {
  icon: null,
  title: '',
  description: '',
};

export default ImportInboxPromoBanner;
